module.exports = __webpack_public_path__ + "static/media/S23-0447_ChickenCrunchers_Mobile_Homepage_Banner_767x845.dad13929.jpg";